import React, { useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import classNames from 'classnames';

import './EventInfo.scss';
import { RootState } from '../../../configs/store';
import RacingDetailContext from '../Context/RacingDetail.context';
import Icon from '../../../components/Icon/Icon';


interface EventInfoProps {
  raceStatus: string
}

export default function EventInfo({
  raceStatus
}: EventInfoProps) {
  const [expandedInfo, setExpandedInfo] = useState(true);
  const { t } = useTranslation('common');
  const { event } = useContext(RacingDetailContext);
  const { selectedTimezone } = useSelector((state: RootState) => state.odds);
  const date = event?.eventStart && utcToZonedTime(event?.eventStart * 1000, selectedTimezone);
  const purse = event.purse?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return (
    <div className="event-info">
      <div className="event-info__header">
        <span>{ t('racingDetail.race', { raceNo: event.raceNo }) }</span>
        &nbsp;|&nbsp;
        { date &&  <span className="event-info__time">{ format(date, 'HH:mm') }</span> }
        &nbsp;
        <Icon
          icon={ expandedInfo ? 'filledI' : 'info' }
          className={
            classNames('event-info__info-btn', {
              'event-info__info-btn--active': expandedInfo
            })
          }
          onClick={ () => setExpandedInfo(!expandedInfo) }
        />

        { /* <Icon icon="streaming" className="event-info__streaming-btn" /> */ }
      </div>
      <div>
        {
          raceStatus !== '' &&
            <div className="event-info__race-status">{ raceStatus }</div>
        }
      </div>

      {
        expandedInfo && (
          <div className="event-info__info--container">
            <div className="event-info__info">
              {
                event.ageRestrictionMale && event.ageRestrictionMale !== 'NULL' &&
                  <span>
                    {
                      t('racingDetail.ageRestriction', { ageRestriction: event.ageRestrictionMale ? event.ageRestrictionMale : '' })
                    }&nbsp;|&nbsp;
                  </span>
              }
              {
                event.distance &&
                  <span>
                    {
                      t('racingDetail.distance', {
                        distance: event.distance !== '0' ? event.distance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
                      })
                    }
                    &nbsp;|&nbsp;
                  </span>
              }
              {
                purse && purse !== '0' &&
                  <>
                    <span>
                      { purse }
                    </span>
                    <span>
                      { event.purseCurrency ?? '' }
                      &nbsp;|&nbsp;
                    </span>
                  </>
              }
              {
                event.type &&
                  <span style={ { textTransform: 'capitalize' } }>
                    { t('racingDetail.type', { type: event.type }) }&nbsp;|&nbsp;
                  </span>
              }
              {
                event.surface &&
                  <span>{ t('racingDetail.surface', { surface: event.surface }) }</span>
              }
            </div>
          </div>
        )
      }
    </div>
  );
}
